<template>
  <div class="container" >
    <!--<van-nav-bar-->
        <!--title="套餐详情"-->
        <!--left-arrow-->
        <!--@click-left="onClickLeft"-->
    <!--&gt;</van-nav-bar>-->
    <div class="card-img">
      <img class="img" :src="cardDetail.cardPic"  mode="widthFix" alt="">
    </div>
    <div class="card-detail">
      <h4>{{cardDetail.cardName}}</h4>
      <div class="card-info">
        <div class="shop">门店：<span class="fw-500">{{storeInfo.name}}</span></div>
        <div class="combo flex-rss">
          <div>套餐：</div>
          <div>
            <div>充{{cardDetail.priceStr}}</div>
            <div v-if="cardDetail.donationStr > 0">送{{cardDetail.donationStr}}</div>
            <div v-if="cardDetail.discount < 100">享{{cardDetail.discount / 10}}折</div>
          </div>
        </div>
        <div class="flex-rss" v-if="cardDetail.coupons && cardDetail.coupons.length > 0">
          <div class="flex-1 flex-shrink0">额外赠送：</div>
          <div v-for="(coupon, index) in cardDetail.coupons" :key="index">
            <div>{{coupon.couponName}} {{coupon.num}}张</div>
          </div>
        </div>
      </div>
      <div class="card-explain">
        <div class="rules-main" v-if="rules">
          <div class="card-explain-tit">适用规则：</div>
          <div class="rules-box" >
            <div class="rules-info" v-if="rules.storeNames">
              <span>1.适用门店： </span><span v-for="(storeName, index) in rules.storeNames" :key="index">{{storeName}} <span v-if="index !== rules.storeNames.length - 1">,</span></span>
            </div>
            <div class="rules-info" v-if="rules.skuNames">
              <span>2.适用项目（到品牌项目）：</span><span v-for="(skuName, index) in rules.skuNames" :key="index">{{skuName}}<span v-if="index !== rules.skuNames.length - 1">,</span></span>
            </div>
            <div class="rules-info"  v-if="(rules.weeks && rules.weeks.length > 0) || rules.duration && rules.duration.length > 0">
              <div class="flex-rss">
                <div> 3.不可用时间段：</div>
                <div>
                  <div v-if="rules.weeks && rules.weeks.length > 0">
                    <span v-for="(week, index) in rules.weeks" :key="index">{{week}}  <span v-if="index !== rules.weeks.length - 1">,</span></span>
                  </div>
                  <div class="flex-rsc" v-if="duration && duration.length > 0">
                    <div v-for="(time, index) in duration" :key="index">
                      <span>{{time.st}}</span>到<span>{{time.et}}</span>
                      <span v-if="index !== duration.length - 1">,</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="description-main" v-if="cardDetail.description">
          <div class="card-explain-tit">卡的描述：</div>
          <div class="description-info">{{cardDetail.description}}</div>
        </div>
      </div>
    </div>
    <div class="bottom-bar-placeholder"></div>
    <div class="bottom-bar-placeholder"></div>
    <div class="btn-box">
      <div class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" @click="buyCard">确认购买</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import WXPay from '../../util/wxpay'
  export default {
    name: 'cardDetail',
    data () {
      return {
        cardDetail: {},
        rules: {},
        packageId: '',
        packageNo: '',
        userCardNo: '',
        userCardId: '',
        payTypeStr: '',
        duration: []
      }
    },
    computed: {
      ...mapState(['openId', 'storeInfo', 'isApp'])
    },
    mounted () {
      const { packageId = '', packageNo = '', userCardNo = '', userCardId = '' } = this.$route.query
      console.log('packageId', packageId)
      console.log('packageNo', packageNo)
      this.packageId = packageId
      this.packageNo = packageNo
      this.userCardNo = userCardNo
      this.userCardId = userCardId
      console.log('storeInfo', this.storeInfo)
      this.getCardDetail()
    },
    methods: {
      getCardDetail () {
        const {packageId, packageNo, userCardNo, userCardId} = this
        this.$api.pay.getPackageDetail({
          packageId,
          packageNo,
          userCardNo,
          userCardId
        }).then(res => {
          console.log('res', res)
          if (res.errCode === '0') {
            this.cardDetail = res.data
            this.rules = this.cardDetail.rules
            const { duration = [] } = this.rules
            if (duration && duration.length >= 1) {
              duration.forEach(item => {
                let st = item.st.toString()
                let et = item.et.toString()
                item.st = st.slice(0, 4) + '-' + st.slice(4, 6) + '-' + st.slice(6)
                item.et = et.slice(0, 4) + '-' + et.slice(4, 6) + '-' + et.slice(6)
              })
            }
            this.duration = duration
          } else {
            this.$toast(res.errMsg)
          }
        })
      },
      buyCard () {
        const { cardId, userCardNo = ''} = this.cardDetail
        const {packageId} = this
        console.log('userCardNo', userCardNo)
        if (!userCardNo) {
          this.$router.replace({ path: '/memberInfo', query: {cardId, packageId} })
        } else {
          this.payInfo(userCardNo)
        }
      },
      payInfo () {
        let { loading, openId, packageId, payTypeStr } = this
        const { cardId, userCardId } = this.cardDetail
        let source
        if (this.isApp === 'isAlipay') {
          source = '3'
          payTypeStr = 6
        } else if (this.isApp === 'isWeixin') {
          payTypeStr = 5
          source = '2'
        }
        if (loading) return
        this.loading = true
        this.$api.pay.openCardPayInfo({
          payType: payTypeStr,
          cardId,
          packageId,
          userCardId,
          openId,
          source
        }).then(res => {
          console.log('res', res)
          if (res.errCode === '0') {
            this.loading = false
            const { payType } = res.data
            if (payType === 'wxPay') { // 微信支付
              console.log('isApp', this.isApp)
              this.callWXPay(res.data)
            } else if (payType === 'aliPay') {
              this.aliPay(res.data)
            } else if (payType === 'cardPay') {
              this.paySuccess(res.data)
            } else if (payType === 'couponPay') {
              this.paySuccess(res.data)
            }
          } else {
            this.loading = false
            this.$toast(res.errMsg)
          }
        })
      },
      aliPay (obj) {
        ap.tradePay({
          tradeNO: obj.aliTradeNo
        }, (res) => {
          console.log('aliPay', res)
          if (res.resultCode === '9000') {
            this.paySuccess(obj)
          }
        });
      },
      callWXPay (obj) {
        function payCallback(payResult) {
          // 客户端，支付成功
          if (payResult === 'ok') {
            console.log('支付成功')
            this.paySuccess(obj)
            // 客户端，用户取消
          } else if (payResult === 'cancel') {
            console.log('支付失败')
            // do nothing
            // 客户端，其他错误导致支付失败
          } else {
            this.$toast('支付失败，请稍后重试')
          }
        }
        WXPay.callWXPay(obj, payCallback.bind(this))
      },
      paySuccess (obj) {
        const {tradeNo} = obj
        this.$router.replace({ path: '/openCardSuccess', query: { router: 'recharge',tradeNo } })
      },
    }
  }
</script>

<style scoped lang="stylus">
  .card-img
    padding 10px 20px
    img
      width 100%
      height auto
  .card-detail
    padding 0 20px 30px
    .card-tit
      margin-top 36px
      font-size 16px
    .card-info
      padding 10px
      background #fff
      border-radius 4px
      font-size 14px
      line-height 1.5
      font-weight 500
      color #333
      .combo
        margin-top 5px
    h4
      font-weight 500
      font-size 16px
      line-height 3em
      color #000
    .card-explain
      margin-top 10px
      padding 15px
      background #fff
      border-radius 4px
      color #333
      line-height 1.5
      .description-main
        margin-top 10px
        color #333
        font-weight 500
        .description-info
          padding 10px
          font-size 12px
      .card-explain-tit
        font-size 14px
        font-weight 500
        line-height 20px
      .rules-box
        padding 10px
        font-size 12px
        font-weight 500
        .rules-info
          margin-bottom 5px
  .btn-box
    position fixed
    bottom 0
    left 0
    right 0
    padding 20px
    background #fff
</style>
